/* eslint no-underscore-dangle: 0 */
export default class Service {
  constructor(client) {
    this._client = client;
  }
}
